var hideSwiperControls = new function () {
  this.init = function () {
    $('.swiper-container').each(function () {
      if ($(this).find('.swiper-wrapper').children().length < 2) {
        $(this).find('.swiper-pagination').add($(this).find('.swiper-button-prev')).add($(this).find('.swiper-button-next')).hide();
      }
    });
  }
}
